// Local Imports
import {
  topPostImg,
  upgradeOffer1,
  upgradeOffer2,
  upgradeOffer3,
  upgradeOffer4,
  upgradeOffer5,
  upgradeOffer6,
  upgradeOffer7,
  upgradeOffer8,
  upgradeOffer9,
} from '@/assets/images';

// ==================== Country Data ====================
export const countryList = [
  {
    name: 'United States',
    code: '+1',
    flag: 'fi fi-us',
    format: '000-000-0000'
  },
  {
    name: 'Afghanistan',
    code: '+93',
    flag: 'fi fi-af',
    format: '000-000-0000'
  },
  {
    name: 'Albania',
    code: '+355',
    flag: 'fi fi-al',
    format: '000-000-0000'
  },
  {
    name: 'Algeria',
    code: '+213',
    flag: 'fi fi-dz',
    format: '000-000-0000'
  },
  {
    name: 'Andorra',
    code: '+376',
    flag: 'fi fi-ad',
    format: '000-000'
  },
  {
    name: 'Angola',
    code: '+244',
    flag: 'fi fi-ao',
    format: '000-000-0000'
  },
  {
    name: 'Antigua and Barbuda',
    code: '+1-268',
    flag: 'fi fi-ag',
    format: '000-000-0000'
  },
  {
    name: 'Argentina',
    code: '+54',
    flag: 'fi fi-ar',
    format: '000-000-0000'
  },
  {
    name: 'Armenia',
    code: '+374',
    flag: 'fi fi-am',
    format: '00-000-0000'
  },
  {
    name: 'Australia',
    code: '+61',
    flag: 'fi fi-au',
    format: '000-000-0000'
  },
  {
    name: 'Austria',
    code: '+43',
    flag: 'fi fi-at',
    format: '000-000-0000'
  },
  {
    name: 'Azerbaijan',
    code: '+994',
    flag: 'fi fi-az',
    format: '00-000-0000'
  },
  {
    name: 'Bahamas',
    code: '+1-242',
    flag: 'fi fi-bs',
    format: '000-000-0000'
  },
  {
    name: 'Bahrain',
    code: '+973',
    flag: 'fi fi-bh',
    format: '0000-0000'
  },
  {
    name: 'Bangladesh',
    code: '+880',
    flag: 'fi fi-bd',
    format: '0000-0000'
  },
  {
    name: 'Barbados',
    code: '+1-246',
    flag: 'fi fi-bb',
    format: '000-000-0000'
  },
  {
    name: 'Belarus',
    code: '+375',
    flag: 'fi fi-by',
    format: '00-000-0000'
  },
  {
    name: 'Belgium',
    code: '+32',
    flag: 'fi fi-be',
    format: '000-000-0000'
  },
  {
    name: 'Belize',
    code: '+501',
    flag: 'fi fi-bz',
    format: '000-000'
  },
  {
    name: 'Benin',
    code: '+229',
    flag: 'fi fi-bj',
    format: '00-0000-0000'
  },
  {
    name: 'Bhutan',
    code: '+975',
    flag: 'fi fi-bt',
    format: '00-0000'
  },
  {
    name: 'Bolivia',
    code: '+591',
    flag: 'fi fi-bo',
    format: '0-000-0000'
  },
  {
    name: 'Bosnia and Herzegovina',
    code: '+387',
    flag: 'fi fi-ba',
    format: '00-000-0000'
  },
  {
    name: 'Botswana',
    code: '+267',
    flag: 'fi fi-bw',
    format: '000-000-0000'
  },
  {
    name: 'Brazil',
    code: '+55',
    flag: 'fi fi-br',
    format: '00-0000-0000'
  },
  {
    name: 'Brunei',
    code: '+673',
    flag: 'fi fi-bn',
    format: '000-0000'
  },
  {
    name: 'Bulgaria',
    code: '+359',
    flag: 'fi fi-bg',
    format: '000-000-0000'
  },
  {
    name: 'Burkina Faso',
    code: '+226',
    flag: 'fi fi-bf',
    format: '00-00-0000'
  },
  {
    name: 'Burundi',
    code: '+257',
    flag: 'fi fi-bi',
    format: '00-00-0000'
  },
  {
    name: 'Cambodia',
    code: '+855',
    flag: 'fi fi-kh',
    format: '00-000-000'
  },
  {
    name: 'Cameroon',
    code: '+237',
    flag: 'fi fi-cm',
    format: '0000-0000'
  },
  {
    name: 'Cape Verde',
    code: '+238',
    flag: 'fi fi-cv',
    format: '000-0000'
  },
  {
    name: 'Central African Republic',
    code: '+236',
    flag: 'fi fi-cf',
    format: '00-00-0000'
  },
  {
    name: 'Chad',
    code: '+235',
    flag: 'fi fi-td',
    format: '00-00-0000'
  },
  {
    name: 'Chile',
    code: '+56',
    flag: 'fi fi-cl',
    format: '0-0000-0000'
  },
  {
    name: 'China',
    code: '+86',
    flag: 'fi fi-cn',
    format: '0000-0000'
  },
  {
    name: 'Colombia',
    code: '+57',
    flag: 'fi fi-co',
    format: '000-000-0000'
  },
  {
    name: 'Comoros',
    code: '+269',
    flag: 'fi fi-km',
    format: '000-0000'
  },
  {
    name: 'Congo Congo-Brazzaville',
    code: '+242',
    flag: 'fi fi-cg',
    format: '000-0000'
  },
  {
    name: 'Congo DRC',
    code: '+243',
    flag: 'fi fi-cd',
    format: '000-000-0000'
  },
  {
    name: 'Costa Rica',
    code: '+506',
    flag: 'fi fi-cr',
    format: '0000-0000'
  },
  {
    name: 'Croatia',
    code: '+385',
    flag: 'fi fi-hr',
    format: '00-000-000'
  },
  {
    name: 'Cuba',
    code: '+53',
    flag: 'fi fi-cu',
    format: '0000-0000'
  },
  {
    name: 'Cyprus',
    code: '+357',
    flag: 'fi fi-cy',
    format: '00-00-0000'
  },
  {
    name: 'Czechia',
    code: '+420',
    flag: 'fi fi-cz',
    format: '000-000-000'
  },
  {
    name: 'Denmark',
    code: '+45',
    flag: 'fi fi-dk',
    format: '00-00-0000'
  },
  {
    name: 'Djibouti',
    code: '+253',
    flag: 'fi fi-dj',
    format: '00-00-0000'
  },
  {
    name: 'Dominica',
    code: '+1-767',
    flag: 'fi fi-dm',
    format: '000-000-0000'
  },
  {
    name: 'Dominican Republic',
    code: '+1-809',
    flag: 'fi fi-do',
    format: '000-000-0000'
  },
  {
    name: 'Ecuador',
    code: '+593',
    flag: 'fi fi-ec',
    format: '0-000-0000'
  },
  {
    name: 'Egypt',
    code: '+20',
    flag: 'fi fi-eg',
    format: '00-000-0000'
  },
  {
    name: 'El Salvador',
    code: '+503',
    flag: 'fi fi-sv',
    format: '0000-0000'
  },
  {
    name: 'Equatorial Guinea',
    code: '+240',
    flag: 'fi fi-gq',
    format: '000-0000'
  },
  {
    name: 'Eritrea',
    code: '+291',
    flag: 'fi fi-er',
    format: '0-000-0000'
  },
  {
    name: 'Estonia',
    code: '+372',
    flag: 'fi fi-ee',
    format: '000-0000'
  },
  {
    name: 'Eswatini',
    code: '+268',
    flag: 'fi fi-sz',
    format: '00-00-0000'
  },
  {
    name: 'Ethiopia',
    code: '+251',
    flag: 'fi fi-et',
    format: '00-000-0000'
  },
  {
    name: 'Fiji',
    code: '+679',
    flag: 'fi fi-fj',
    format: '000-0000'
  },
  {
    name: 'Finland',
    code: '+358',
    flag: 'fi fi-fi',
    format: '00-000-0000'
  },
  {
    name: 'France',
    code: '+33',
    flag: 'fi fi-fr',
    format: '0-00-00-00-00'
  },
  {
    name: 'Gabon',
    code: '+241',
    flag: 'fi fi-ga',
    format: '0-00-0000'
  },
  {
    name: 'Gambia',
    code: '+220',
    flag: 'fi fi-gm',
    format: '000-0000'
  },
  {
    name: 'Georgia',
    code: '+995',
    flag: 'fi fi-ge',
    format: '000-00-00-00'
  },
  {
    name: 'Germany',
    code: '+49',
    flag: 'fi fi-de',
    format: '000-0000-0000'
  },
  {
    name: 'Ghana',
    code: '+233',
    flag: 'fi fi-gh',
    format: '000-000-000'
  },
  {
    name: 'Greece',
    code: '+30',
    flag: 'fi fi-gr',
    format: '000-000-0000'
  },
  {
    name: 'Grenada',
    code: '+1-473',
    flag: 'fi fi-gd',
    format: '000-000-0000'
  },
  {
    name: 'Guatemala',
    code: '+502',
    flag: 'fi fi-gt',
    format: '0000-0000'
  },
  {
    name: 'Guinea',
    code: '+224',
    flag: 'fi fi-gn',
    format: '00-000-0000'
  },
  {
    name: 'Guinea-Bissau',
    code: '+245',
    flag: 'fi fi-gw',
    format: '00-0000'
  },
  {
    name: 'Guyana',
    code: '+592',
    flag: 'fi fi-gy',
    format: '000-0000'
  },
  {
    name: 'Haiti',
    code: '+509',
    flag: 'fi fi-ht',
    format: '000-0000'
  },
  {
    name: 'Honduras',
    code: '+504',
    flag: 'fi fi-hn',
    format: '0000-0000'
  },
  {
    name: 'Hungary',
    code: '+36',
    flag: 'fi fi-hu',
    format: '00-000-0000'
  },
  {
    name: 'Iceland',
    code: '+354',
    flag: 'fi fi-is',
    format: '000-0000'
  },
  {
    name: 'India',
    code: '+91',
    flag: 'fi fi-in',
    format: '00000-00000'
  },
  {
    name: 'Indonesia',
    code: '+62',
    flag: 'fi fi-id',
    format: '00-0000-0000'
  },
  {
    name: 'Iran',
    code: '+98',
    flag: 'fi fi-ir',
    format: '000-000-0000'
  },
  {
    name: 'Iraq',
    code: '+964',
    flag: 'fi fi-iq',
    format: '000-000-0000'
  },
  {
    name: 'Ireland',
    code: '+353',
    flag: 'fi fi-ie',
    format: '00-000-0000'
  },
  {
    name: 'Israel',
    code: '+972',
    flag: 'fi fi-il',
    format: '00-000-0000'
  },
  {
    name: 'Italy',
    code: '+39',
    flag: 'fi fi-it',
    format: '000-0000-000'
  },
  {
    name: 'Jamaica',
    code: '+1-876',
    flag: 'fi fi-jm',
    format: '000-000-0000'
  },
  {
    name: 'Japan',
    code: '+81',
    flag: 'fi fi-jp',
    format: '000-000-0000'
  },
  {
    name: 'Jordan',
    code: '+962',
    flag: 'fi fi-jo',
    format: '00-0000-0000'
  },
  {
    name: 'Kazakhstan',
    code: '+7',
    flag: 'fi fi-kz',
    format: '000-000-0000'
  },
  {
    name: 'Kenya',
    code: '+254',
    flag: 'fi fi-ke',
    format: '000-000000'
  },
  {
    name: 'Kiribati',
    code: '+686',
    flag: 'fi fi-ki',
    format: '00-0000'
  },
  {
    name: 'Kuwait',
    code: '+965',
    flag: 'fi fi-kw',
    format: '0000-0000'
  },
  {
    name: 'Kyrgyzstan',
    code: '+996',
    flag: 'fi fi-kg',
    format: '000-000-000'
  },
  {
    name: 'Laos',
    code: '+856',
    flag: 'fi fi-la',
    format: '00-000-000'
  },
  {
    name: 'Latvia',
    code: '+371',
    flag: 'fi fi-lv',
    format: '0000-0000'
  },
  {
    name: 'Lebanon',
    code: '+961',
    flag: 'fi fi-lb',
    format: '00-000-000'
  },
  {
    name: 'Lesotho',
    code: '+266',
    flag: 'fi fi-ls',
    format: '000-0000'
  },
  {
    name: 'Liberia',
    code: '+231',
    flag: 'fi fi-lr',
    format: '000-000-000'
  },
  {
    name: 'Libya',
    code: '+218',
    flag: 'fi fi-ly',
    format: '00-0000-0000'
  },
  {
    name: 'Liechtenstein',
    code: '+423',
    flag: 'fi fi-li',
    format: '000-000-0000'
  },
  {
    name: 'Lithuania',
    code: '+370',
    flag: 'fi fi-lt',
    format: '00-000-0000'
  },
  {
    name: 'Luxembourg',
    code: '+352',
    flag: 'fi fi-lu',
    format: '000-0000'
  },
  {
    name: 'Madagascar',
    code: '+261',
    flag: 'fi fi-mg',
    format: '00-00-00000'
  },
  {
    name: 'Malawi',
    code: '+265',
    flag: 'fi fi-mw',
    format: '00-0000-0000'
  },
  {
    name: 'Malaysia',
    code: '+60',
    flag: 'fi fi-my',
    format: '000-000-0000'
  },
  {
    name: 'Maldives',
    code: '+960',
    flag: 'fi fi-mv',
    format: '000-0000'
  },
  {
    name: 'Mali',
    code: '+223',
    flag: 'fi fi-ml',
    format: '00-00-0000'
  },
  {
    name: 'Malta',
    code: '+356',
    flag: 'fi fi-mt',
    format: '0000-0000'
  },
  {
    name: 'Marshall Islands',
    code: '+692',
    flag: 'fi fi-mh',
    format: '000-000-0000'
  },
  {
    name: 'Mauritania',
    code: '+222',
    flag: 'fi fi-mr',
    format: '00-00-0000'
  },
  {
    name: 'Mauritius',
    code: '+230',
    flag: 'fi fi-mu',
    format: '000-0000'
  },
  {
    name: 'Me0ico',
    code: '+52',
    flag: 'fi fi-mx',
    format: '000-000-0000'
  },
  {
    name: 'Micronesia',
    code: '+691',
    flag: 'fi fi-fm',
    format: '000-000-0000'
  },
  {
    name: 'Moldova',
    code: '+373',
    flag: 'fi fi-md',
    format: '00-000-000'
  },
  {
    name: 'Monaco',
    code: '+377',
    flag: 'fi fi-mc',
    format: '00-000-000'
  },
  {
    name: 'Mongolia',
    code: '+976',
    flag: 'fi fi-mn',
    format: '00-000-0000'
  },
  {
    name: 'Montenegro',
    code: '+382',
    flag: 'fi fi-me',
    format: '00-000-000'
  },
  {
    name: 'Morocco',
    code: '+212',
    flag: 'fi fi-ma',
    format: '00-0000-0000'
  },
  {
    name: 'Mozambique',
    code: '+258',
    flag: 'fi fi-mz',
    format: '00-000-0000'
  },
  {
    name: 'Myanmar Burma',
    code: '+95',
    flag: 'fi fi-mm',
    format: '00-000-000'
  },
  {
    name: 'Namibia',
    code: '+264',
    flag: 'fi fi-na',
    format: '00-000-0000'
  },
  {
    name: 'Nauru',
    code: '+674',
    flag: 'fi fi-nr',
    format: '000-000'
  },
  {
    name: 'Nepal',
    code: '+977',
    flag: 'fi fi-np',
    format: '00-000-0000'
  },
  {
    name: 'Netherlands',
    code: '+31',
    flag: 'fi fi-nl',
    format: '00-000-0000'
  },
  {
    name: 'New Zealand',
    code: '+64',
    flag: 'fi fi-nz',
    format: '000-000-0000'
  },
  {
    name: 'Nicaragua',
    code: '+505',
    flag: 'fi fi-ni',
    format: '0000-0000'
  },
  {
    name: 'Niger',
    code: '+227',
    flag: 'fi fi-ne',
    format: '00-00-0000'
  },
  {
    name: 'Nigeria',
    code: '+234',
    flag: 'fi fi-ng',
    format: '000-000-0000'
  },
  {
    name: 'North Macedonia',
    code: '+389',
    flag: 'fi fi-mk',
    format: '00-000-000'
  },
  {
    name: 'Norway',
    code: '+47',
    flag: 'fi fi-no',
    format: '000-00-000'
  },
  {
    name: 'Oman',
    code: '+968',
    flag: 'fi fi-om',
    format: '00-000-0000'
  },
  {
    name: 'Pakistan',
    code: '+92',
    flag: 'fi fi-pk',
    format: '000-0000000'
  },
  {
    name: 'Palau',
    code: '+680',
    flag: 'fi fi-pw',
    format: '000-0000'
  },
  {
    name: 'Palestine',
    code: '+970',
    flag: 'fi fi-ps',
    format: '00-000-0000'
  },
  {
    name: 'Panama',
    code: '+507',
    flag: 'fi fi-pa',
    format: '000-0000'
  },
  {
    name: 'Papua New Guinea',
    code: '+675',
    flag: 'fi fi-pg',
    format: '000-0000'
  },
  {
    name: 'Paraguay',
    code: '+595',
    flag: 'fi fi-py',
    format: '000-000-000'
  },
  {
    name: 'Peru',
    code: '+51',
    flag: 'fi fi-pe',
    format: '000-000-000'
  },
  {
    name: 'Philippines',
    code: '+63',
    flag: 'fi fi-ph',
    format: '000-000-0000'
  },
  {
    name: 'Poland',
    code: '+48',
    flag: 'fi fi-pl',
    format: '000-000-000'
  },
  {
    name: 'Portugal',
    code: '+351',
    flag: 'fi fi-pt',
    format: '000-000-000'
  },
  {
    name: 'Qatar',
    code: '+974',
    flag: 'fi fi-qa',
    format: '0000-0000'
  },
  {
    name: 'Romania',
    code: '+40',
    flag: 'fi fi-ro',
    format: '000-000-000'
  },
  {
    name: 'Russia',
    code: '+7',
    flag: 'fi fi-ru',
    format: '000-000-00-00'
  },
  {
    name: 'Rwanda',
    code: '+250',
    flag: 'fi fi-rw',
    format: '000-000-000'
  },
  {
    name: 'Saint Kitts and Nevis',
    code: '+1-869',
    flag: 'fi fi-kn',
    format: '000-000-0000'
  },
  {
    name: 'Saint Lucia',
    code: '+1-758',
    flag: 'fi fi-lc',
    format: '000-000-0000'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: '+1-784',
    flag: 'fi fi-vc',
    format: '000-000-0000'
  },
  {
    name: 'Samoa',
    code: '+685',
    flag: 'fi fi-ws',
    format: '00-0000'
  },
  {
    name: 'San Marino',
    code: '+378',
    flag: 'fi fi-sm',
    format: '000-000-000'
  },
  {
    name: 'Saudi Arabia',
    code: '+966',
    flag: 'fi fi-sa',
    format: '00-000-0000'
  },
  {
    name: 'Senegal',
    code: '+221',
    flag: 'fi fi-sn',
    format: '00-000-0000'
  },
  {
    name: 'Serbia',
    code: '+381',
    flag: 'fi fi-rs',
    format: '00-000-0000'
  },
  {
    name: 'Seychelles',
    code: '+248',
    flag: 'fi fi-sc',
    format: '0-000-0000'
  },
  {
    name: 'Sierra Leone',
    code: '+232',
    flag: 'fi fi-sl',
    format: '00-000-000'
  },
  {
    name: 'Singapore',
    code: '+65',
    flag: 'fi fi-sg',
    format: '0000-0000'
  },
  {
    name: 'Slovakia',
    code: '+421',
    flag: 'fi fi-sk',
    format: '00-000-000'
  },
  {
    name: 'Slovenia',
    code: '+386',
    flag: 'fi fi-si',
    format: '00-000-000'
  },
  {
    name: 'Solomon Islands',
    code: '+677',
    flag: 'fi fi-sb',
    format: '000-000'
  },
  {
    name: 'Somalia',
    code: '+252',
    flag: 'fi fi-so',
    format: '00-000-0000'
  },
  {
    name: 'South Africa',
    code: '+27',
    flag: 'fi fi-za',
    format: '00-000-0000'
  },
  {
    name: 'South Korea',
    code: '+82',
    flag: 'fi fi-kr',
    format: '000-0000-0000'
  },
  {
    name: 'Spain',
    code: '+34',
    flag: 'fi fi-es',
    format: '000-000-000'
  },
  {
    name: 'Sri Lanka',
    code: '+94',
    flag: 'fi fi-lk',
    format: '00-000-0000'
  },
  {
    name: 'Sudan',
    code: '+249',
    flag: 'fi fi-sd',
    format: '00-000-0000'
  },
  {
    name: 'Suriname',
    code: '+597',
    flag: 'fi fi-sr',
    format: '000-0000'
  },
  {
    name: 'Sweden',
    code: '+46',
    flag: 'fi fi-se',
    format: '00-000-0000'
  },
  {
    name: 'Switzerland',
    code: '+41',
    flag: 'fi fi-ch',
    format: '00-000-0000'
  },
  {
    name: 'Syria',
    code: '+963',
    flag: 'fi fi-sy',
    format: '00-0000-000'
  },
  {
    name: 'Tajikistan',
    code: '+992',
    flag: 'fi fi-tj',
    format: '00-000-0000'
  },
  {
    name: 'Tanzania',
    code: '+255',
    flag: 'fi fi-tz',
    format: '00-000-0000'
  },
  {
    name: 'Thailand',
    code: '+66',
    flag: 'fi fi-th',
    format: '000-000-0000'
  },
  {
    name: 'Togo',
    code: '+228',
    flag: 'fi fi-tg',
    format: '00-000-000'
  },
  {
    name: 'Tonga',
    code: '+676',
    flag: 'fi fi-to',
    format: '000-0000'
  },
  {
    name: 'Trinidad and Tobago',
    code: '+1-868',
    flag: 'fi fi-tt',
    format: '000-000-0000'
  },
  {
    name: 'Tunisia',
    code: '+216',
    flag: 'fi fi-tn',
    format: '00-000-000'
  },
  {
    name: 'Turkey',
    code: '+90',
    flag: 'fi fi-tr',
    format: '000-000-0000'
  },
  {
    name: 'Turkmenistan',
    code: '+993',
    flag: 'fi fi-tm',
    format: '00-000-000'
  },
  {
    name: 'Tuvalu',
    code: '+688',
    flag: 'fi fi-tv',
    format: '00-000'
  },
  {
    name: 'Uganda',
    code: '+256',
    flag: 'fi fi-ug',
    format: '000-0000000'
  },
  {
    name: 'Ukraine',
    code: '+380',
    flag: 'fi fi-ua',
    format: '00-000-0000'
  },
  {
    name: 'United Arab Emirates',
    code: '+971',
    flag: 'fi fi-ae',
    format: '00-000-0000'
  },
  {
    name: 'United Kingdom',
    code: '+44',
    flag: 'fi fi-gb',
    format: '0000-000-000'
  },
  {
    name: 'Uruguay',
    code: '+598',
    flag: 'fi fi-uy',
    format: '000-000-000'
  },
  {
    name: 'Uzbekistan',
    code: '+998',
    flag: 'fi fi-uz',
    format: '00-000-0000'
  },
  {
    name: 'Vanuatu',
    code: '+678',
    flag: 'fi fi-vu',
    format: '000-0000'
  },
  {
    name: 'Vatican City',
    code: '+379',
    flag: 'fi fi-va',
    format: '00-0000-000'
  },
  {
    name: 'Venezuela',
    code: '+58',
    flag: 'fi fi-ve',
    format: '000-000-0000'
  },
  {
    name: 'Vietnam',
    code: '+84',
    flag: 'fi fi-vn',
    format: '00-0000-0000'
  },
  {
    name: 'Yemen',
    code: '+967',
    flag: 'fi fi-ye',
    format: '00-000-0000'
  },
  {
    name: 'Zambia',
    code: '+260',
    flag: 'fi fi-zm',
    format: '00-000-0000'
  },
  {
    name: 'Zimbabwe',
    code: '+263',
    flag: 'fi fi-zw',
    format: '00-000-0000'
  }
];

export const countryNameRecord = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo (Democratic Republic)',
  CR: 'Costa Rica',
  CI: 'Côte d\'Ivoire',
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GR: 'Greece',
  GD: 'Grenada',
  GT: 'Guatemala',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HN: 'Honduras',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Lao People\'s Democratic Republic',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MX: 'Mexico',
  FM: 'Micronesia',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  MK: 'North Macedonia',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  QA: 'Qatar',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

// ==================== Constants ====================
export const deliverables = [
  'Unboxing',
  'Product Stylings',
  'How To',
  'Before & After',
  'Product Reviews',
  'Product Demos',
  'Product Showcase',
  'Product Testing'
];

export const ratesSocialChannel = [
  'Instagram',
  'Product Stylings',
  'Pinterest',
  'Youtube',
  'Raw UGC Files'
];

export const allowedPlatforms = ['instagram', 'pinterest', 'youtu.be', 'youtube', 'tiktok'];

export const urlPattern = new RegExp(
  '^(https?:\\/\\/)?' + '(www\\.)?' + '([\\w-]+\\.)+[a-zA-Z]{2,}' + '([\\/\\w-@:%_+.~#?&=]*)?$'
);

// ==================== Mockup Data ====================
export const upgradeOfferContentData = [
  {
    title: 'Attract Premium Brands',
    description: 'Showcase your past brand partnerships to demonstrate your professionalism.',
    image: upgradeOffer2
  },
  {
    title: 'Videos get more Brands',
    description: 'Video converts 4x more than static images.',
    image: upgradeOffer3
  },
  {
    title: 'Showcase Trusted Reviews',
    description: 'Brands collaborate much more when they see trusted reviews.',
    image: upgradeOffer4
  },
  {
    title: 'Uncover your best facts',
    description: 'Replace generic data with your facts tailored to YOU',
    image: upgradeOffer7
  },
  {
    title: 'Get Paid More',
    description: 'Make sure brands see (only) your best content.',
    image: upgradeOffer8
  },
  {
    title: 'Unified Links Hub',
    description: 'Instant access to your diverse online presence.',
    image: upgradeOffer6
  },
  {
    title: 'Uncertainty blocks brand collabs',
    description: 'Clear brand\'s suspicion by verifying your identity.',
    image: upgradeOffer9
  },
  {
    title: 'Stunning, Customizable Designs',
    description: 'Designs unique to your personal brand.',
    image: upgradeOffer5
  },
  {
    title: '',
    description: '',
    image: upgradeOffer1,
  },
];

export const freeVideosData = [
  {
    thumbnailUrl: topPostImg,
    videoUrl: '',
    id: 1
  },
  {
    thumbnailUrl: topPostImg,
    videoUrl: '',
    id: 2
  },
  {
    thumbnailUrl: topPostImg,
    videoUrl: '',
    id: 3
  },
  {
    thumbnailUrl: topPostImg,
    videoUrl: '',
    id: 5
  }
];

export const linksSampleData = [
  {
    channelName: 'LTK',
    link: '',
    isIncluded: true
  },
  {
    channelName: 'Amazon Storefront',
    link: '',
    isIncluded: true
  },
  {
    channelName: 'Collabstr',
    link: '',
    isIncluded: true
  },
  {
    channelName: 'Upfluence',
    link: '',
    isIncluded: true
  },
  {
    channelName: 'Shopify Creator',
    link: '',
    isIncluded: true
  },
  {
    channelName: 'Channel 3',
    link: '',
    isIncluded: true
  },
  {
    channelName: 'Channel 4',
    link: '',
    isIncluded: true
  },
  {
    channelName: 'Channel 5',
    link: '',
    isIncluded: true
  },
];

export const dummyReviews = [
  {
    id: 1,
    channel: 'Chanel',
    date: '08/14/2024',
    description:
      'Janey was awesome to work with. She asked us what we were looking for and delivered exactly that! We loved the video so much that we even gave her a bonus!',
    cooperationRating: 5,
    timelinessRating: 4,
    contentQualityRating: 5,
    profileImage: '/placeholder.svg?height=80&width=80',
    isBrand: true,
    brandName: 'ILOLA™ Brand',
    isDummyReview: true
  },
  {
    id: 2,
    channel: 'Lulu Lemon',
    date: '08/14/2024',
    description:
      'I highly recommend any brand to work with Janey. Her content is unique & she is lovely to work with.',
    cooperationRating: 5,
    timelinessRating: 4,
    contentQualityRating: 5,
    profileImage: '/placeholder.svg?height=80&width=80',
    isBrand: true,
    brandName: 'ILOLA™ Brand',
    isDummyReview: true
  },
  {
    id: 3,
    channel: 'ZARA',
    date: '02/14/2025',
    description:
      'Janey was so easy to work with. She was very professional & her content came out beautiful!',
    cooperationRating: 5,
    timelinessRating: 4,
    contentQualityRating: 5,
    profileImage: '/placeholder.svg?height=80&width=80',
    isBrand: true,
    brandName: 'ILOLA™ Brand',
    isDummyReview: true
  },
];

export const stats = [
  {
    id: 1,
    factValue: '3500',
    factName: 'AVERAGE NO. OF VIEWS'
  },
  {
    id: 2,
    factValue: '5000',
    factName: 'AVERAGE NO. OF LIKES'
  },
  {
    id: 3,
    factValue: '1000',
    factName: 'AVERAGE NO. OF Followers'
  }
];

// ==================== Audience Data ====================
export const countriesInitInstaData = [
  {
    percentage: 14,
    country: 'AU'
  },
  {
    percentage: 14,
    country: 'US'
  },
  {
    percentage: 14,
    country: 'ES'
  },
  {
    percentage: 14,
    country: 'IT'
  },
  {
    percentage: 14,
    country: 'GR'
  }
];

export const citiesInitInstaData = [
  {
    city: 'Melbourne',
    percentage: 6500
  },
  {
    city: 'USA',
    percentage: 6500
  },
  {
    city: 'Spain',
    percentage: 6500
  }
];

export const ageInitInstaData = [
  { age_range: "18-24", percentage: 60, fillPercentage: 75 },
  { age_range: "25-34", percentage: 40, fillPercentage: 50 },
  { age_range: "35-44", percentage: 30, fillPercentage: 55 },
  { age_range: "45-54", percentage: 20, fillPercentage: 50 },
  { age_range: "55-64", percentage: 15, fillPercentage: 50 },
  { age_range: "65", percentage: 5, fillPercentage: 50 },
];

export const genderInitInstaData = { female: 72, male: 24, uc: 4 };

export const countriesInitTiktokData = [
  {
    percentage: 21,
    country: 'AU'
  },
  {
    percentage: 21,
    country: 'US'
  },
  {
    percentage: 21,
    country: 'ES'
  },
  {
    percentage: 21,
    country: 'IT'
  },
  {
    percentage: 21,
    country: 'GR'
  }
];

export const citiesInitTiktokData = [
  {
    city: 'Melbourne',
    percentage: 4300
  },
  {
    city: 'USA',
    percentage: 4300
  },
  {
    city: 'Spain',
    percentage: 4300
  }
];

export const ageInitTiktokData = [
  { age_range: "18-24", percentage: 53, fillPercentage: 54 },
  { age_range: "25-34", percentage: 74, fillPercentage: 74 },
  { age_range: "35-44", percentage: 16, fillPercentage: 26 },
  { age_range: "45-54", percentage: 6, fillPercentage: 53 },
  { age_range: "55-64", percentage: 5, fillPercentage: 56 },
  { age_range: "65", percentage: 5, fillPercentage: 23 },
];

export const genderInitTiktokData = { female: 64, male: 19, uc: 17 };

// ==================== Top Interest Sample Data ====================
export const topInterestSampleData = ['Fashion', 'Travel', 'Books', 'Business', 'Food'];

// ==================== Rates Sample Data Base ====================
export const ratesSampleDataBase = [
  { socialChannelName: 'Instagram', minRate: '100', maxRate: '1000' },
  { socialChannelName: 'Tiktok', minRate: '100', maxRate: '1000' },
  { socialChannelName: 'Pinterest', minRate: '100', maxRate: '1000' },
  { socialChannelName: 'Youtube', minRate: '100', maxRate: '1000' },
  { socialChannelName: 'Amazon', minRate: '100', maxRate: '1000' },
  { socialChannelName: 'Twitch', minRate: '100', maxRate: '1000' },
  { socialChannelName: 'Raw UGC Files', minRate: '100', maxRate: '1000' }
];

